import TagSelectorGroup from './tag-selector-group-view'

export default TagSelectorGroup
